import type { ReactNode } from 'react';
import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import type { IconName } from 'Components/frameworks/icon/Icon';
import 'Components/frameworks/icon/Icon';
import { ChoiceList } from 'Components/frameworks/choice-list/ChoiceList';
type Props = {
  choiceLists: Array<{
    choices: Array<{
      icon?: IconName;
      isDisabled?: boolean;
      isIconOnly?: boolean;
      isSelected?: boolean;
      label: ReactNode;
      value: string;
    }>;
    label: string;
    value: string;
  }>;
  className?: string;
  name: string;
  onChange: (name: string, checked: boolean, value: string | boolean) => void;
  title?: string;
};
export const ChoiceLists = ({ choiceLists = [], className, name, onChange, title }: Props) => (
  <fieldset className={classnames('m-0 border-0 p-0', className)}>
    {title && <legend className="mb-10 p-0 text-16 font-bold leading-tight">{title}</legend>}
    {choiceLists.map((choiceList) => (
      <ChoiceList
        choices={choiceList.choices}
        className={classnames('FacetList mb-20', className)}
        key={choiceList.value}
        name={name}
        onChange={onChange}
        title={choiceList.label}
      />
    ))}
  </fieldset>
);
